module.exports = __webpack_public_path__ + "static/meniu_mobile-0609aa497e8f5b4410d7f9f46ad5d79e.mp4";